import {FormState} from "./FormState";
import {crearServicioGuarderia, NuevoServicioGuarderia} from "../../../services/guarderiaServicios";
import {parseCurrency} from "../../../utils/numberUtils";

const generarNuevoServicioGuarderia = (formState: FormState): NuevoServicioGuarderia => {
    return {
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.wasTouched ? formState.descripcion.value : undefined,
        dias: parseInt(formState.dias.value),
        precioTotal: parseCurrency(formState.precioTotal.value, "$", ","),
        horaSalida: formState.horaSalida.wasTouched ? formState.horaSalida.value : undefined
    }
}

export const crearNuevoServicioGuarderia = async (formState: FormState) => {
    const nuevoServicio = generarNuevoServicioGuarderia(formState);
    await crearServicioGuarderia(nuevoServicio);
}